import React from 'react';

const CohortRetentionTable = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground text-sm">
        No cohort data available
      </div>
    );
  }

  const getRetentionColor = (value) => {
    if (value >= 70) return 'bg-success/20 text-success';
    if (value >= 50) return 'bg-warning/20 text-warning';
    return 'bg-error/20 text-error';
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-2 px-3 text-muted-foreground font-medium">Cohort</th>
            <th className="text-center py-2 px-3 text-muted-foreground font-medium">Week 0</th>
            <th className="text-center py-2 px-3 text-muted-foreground font-medium">Week 1</th>
            <th className="text-center py-2 px-3 text-muted-foreground font-medium">Week 2</th>
            <th className="text-center py-2 px-3 text-muted-foreground font-medium">Week 3</th>
            <th className="text-center py-2 px-3 text-muted-foreground font-medium">Week 4</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((cohort, index) => (
            <tr key={index} className="border-b border-border/50">
              <td className="py-2 px-3 font-medium text-foreground">{cohort?.cohort}</td>
              <td className="py-2 px-3 text-center">
                <span className="inline-block px-2 py-1 rounded bg-primary/20 text-primary font-medium">
                  {cohort?.week0}%
                </span>
              </td>
              <td className="py-2 px-3 text-center">
                <span className={`inline-block px-2 py-1 rounded font-medium ${getRetentionColor(cohort?.week1)}`}>
                  {cohort?.week1}%
                </span>
              </td>
              <td className="py-2 px-3 text-center">
                <span className={`inline-block px-2 py-1 rounded font-medium ${getRetentionColor(cohort?.week2)}`}>
                  {cohort?.week2}%
                </span>
              </td>
              <td className="py-2 px-3 text-center">
                <span className={`inline-block px-2 py-1 rounded font-medium ${getRetentionColor(cohort?.week3)}`}>
                  {cohort?.week3}%
                </span>
              </td>
              <td className="py-2 px-3 text-center">
                <span className={`inline-block px-2 py-1 rounded font-medium ${getRetentionColor(cohort?.week4)}`}>
                  {cohort?.week4}%
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Legend */}
      <div className="mt-4 flex items-center gap-4 text-xs">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-success/20"></div>
          <span className="text-muted-foreground">≥70% (Excellent)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-warning/20"></div>
          <span className="text-muted-foreground">50-69% (Good)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-error/20"></div>
          <span className="text-muted-foreground">&lt;50% (At Risk)</span>
        </div>
      </div>
    </div>
  );
};

export default CohortRetentionTable;